import { shopCLient } from '@/services/axiosConfig'
import { CartRes } from './types'

export type GetCartResp = CartRes

type GetCart = (isdn: string) => Promise<GetCartResp>

export const getCart: GetCart = async (isdn) => {
  try {
    const res = await shopCLient.get(`/service/get-cart-list?isdn=${isdn}`)
    return res.data.response
  } catch (e) {
    console.error(e)
  }
}
